export const thanks = {
  placeholderName: 'HERR MUSTERMANN,',
  thankYouText: 'VIELEN DANK FÜR IHRE ANFRAGE!',
  thankYouTextCraftsman: 'VIELEN DANK FÜR IHRE ANGABEN!',
  questionText: 'Bei weiteren Fragen stehe ich Ihnen gerne zur Verfügung.',
  nextStep:
    'Im nächsten Schritt werden Sie von einem Mitarbeiter von {company} kontaktiert, um Ihr Projekt zu starten!',
  moreProjects: 'Haben Sie weitere Projekte?',
  newProjectButtonText: 'Jetzt weiteres Projekt starten',
  underButtonText: 'völlig unverbindlich und ohne versteckte Kosten!',
  recomendationText:
    'Vielen Dank für Ihr Interesse. Wir freuen uns, neue Partner in der HausHeld-Familie begrüssen zu dürfen.',
}
